/**
 * This service defines the language of webapp based on `WEBAPP_LANGUAGE` variable in `.env` file.
 * It sets a proper css class to a `body` tag so that some styles can be adjusted to a certain
 * language. And it sets a variable with the language to an input state.
 */
export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (state) => {
      const { language } = state;
      document.querySelector('body').classList.add(`language-${language}`);
      kasko.dispatchEvent('set-state-input', {
        language,
      });
    },
    { slice: 'queryString' },
  );
};
